module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-contact"
  }, [(_vm.formSubmitted) ? _c('div', {
    staticClass: "form-contact__thank-you"
  }, [_vm._v("Thank you for contacting us, someone from our team will get in touch with you as soon as possible.")]) : _vm._e(), (!_vm.formSubmitted) ? _c('form', {
    staticClass: "form-contact__form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-contact__props-title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "form-contact__props-body",
    domProps: {
      "innerHTML": _vm._s(_vm.props.body)
    }
  }), _c('div', {
    staticClass: "form-contact__group"
  }, [_c('div', {
    staticClass: "form-contact__input",
    class: {
      'form-contact__input--error': _vm.errors.has('clientname')
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clientname')),
      expression: "errors.has('clientname')"
    }],
    staticClass: "form-contact__error"
  }, [_vm._v("Please Input Your Name")]), _c('label', [_vm._v("Your First | Last Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "name": "clientname",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-contact__input",
    class: {
      'form-contact__input--error': _vm.errors.has('clientphone')
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clientphone')),
      expression: "errors.has('clientphone')"
    }],
    staticClass: "form-contact__error"
  }, [_vm._v("Please Input Your Phone Number")]), _c('label', [_vm._v("Your Phone Number")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    attrs: {
      "name": "clientphone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-contact__input",
    class: {
      'form-contact__input--error': _vm.errors.has('clientemail')
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clientemail')),
      expression: "errors.has('clientemail')"
    }],
    staticClass: "form-contact__error"
  }, [_vm._v("Please Input Your Email Address")]), _c('label', [_vm._v("Your Email Address")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    attrs: {
      "name": "clientemail"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._m(0), _c('div', {
    staticClass: "form-contact__radio"
  }, [_c('div', {
    staticClass: "form-contact__radio-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPatient),
      expression: "newPatient"
    }],
    staticClass: "form-contact__input--radio",
    attrs: {
      "name": "newpatient",
      "value": "yes",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.newPatient, "yes")
    },
    on: {
      "change": function($event) {
        _vm.newPatient = "yes"
      }
    }
  }), _c('span', {
    staticClass: "form-contact__radio-overlay"
  }), _c('label', {
    staticClass: "form-contact__label"
  }, [_vm._v("Yes")])]), _c('div', {
    staticClass: "form-contact__radio-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPatient),
      expression: "newPatient"
    }],
    staticClass: "form-contact__input--radio",
    attrs: {
      "name": "newpatient",
      "value": "no",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.newPatient, "no")
    },
    on: {
      "change": function($event) {
        _vm.newPatient = "no"
      }
    }
  }), _c('span', {
    staticClass: "form-contact__radio-overlay"
  }), _c('label', {
    staticClass: "form-contact__label"
  }, [_vm._v("No")])])]), _c('div', {
    staticClass: "form-contact__textarea"
  }, [_c('label', [_vm._v("Reason for coming | Message")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    attrs: {
      "name": "clientmessage"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-contact__checkbox"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.contactPermission),
      expression: "contactPermission"
    }],
    attrs: {
      "type": "checkbox",
      "name": "contactpermission"
    },
    domProps: {
      "checked": Array.isArray(_vm.contactPermission) ? _vm._i(_vm.contactPermission, null) > -1 : (_vm.contactPermission)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.contactPermission,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.contactPermission = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.contactPermission = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.contactPermission = $$c
        }
      }
    }
  }), _c('label', {
    staticClass: "form-contact__label",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("I allow Blacker Orthodontics to contact me through text messages.")])]), _vm._m(1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-contact__input"
  }, [_c('label', [_vm._v("First time patient?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-contact__input--button"
  }, [_c('input', {
    attrs: {
      "type": "submit",
      "value": "send"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dc4ac5c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/form/contact-form/contact-form.pug
// module id = 631
// module chunks = 1